import React from "react";

export default function Unauthorized() {
  const goBackSmart = () => {
    try {
      if (window.history.length > 1) { window.history.back(); return; }
      const ref = document.referrer || "";
      if (ref) { window.location.href = ref; } else { window.location.href = "/home"; }
    } catch { window.location.href = "/home"; }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "grid",
        placeItems: "center",
        padding: "var(--sp-4)",
        boxSizing: "border-box",
      }}
    >
      <section
        className="panel"
        role="alert"
        aria-live="polite"
        style={{ width: "100%", maxWidth: 420, padding: "var(--sp-7) var(--sp-6)", textAlign: "center" }}
      >
        <div
          style={{
            width: 54,
            height: 54,
            borderRadius: "var(--radius-md)",
            margin: "0 auto var(--sp-4)",
            display: "grid",
            placeItems: "center",
            background: "var(--accent-dark)",
            color: "var(--accent-dark-ink)",
            boxShadow: "0 12px 30px -12px rgba(178,58,82,.55)",
          }}
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
            <path d="M7 11V8a5 5 0 0 1 10 0v3" strokeLinecap="round" strokeLinejoin="round" />
            <rect x="5" y="11" width="14" height="10" rx="2.5" ry="2.5" />
            <path d="M12 15v3" strokeLinecap="round" />
          </svg>
        </div>

        <h1 style={{ fontSize: 20, fontWeight: 700 }}>Access Denied</h1>
        <p style={{ fontSize: 13, color: "var(--text-2)", marginTop: 8, marginBottom: "var(--sp-5)" }}>
          You don&rsquo;t have permission to view this page. If this feels unexpected, contact an administrator.
        </p>

        <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
          <button className="btn btn-primary" onClick={() => (window.location.href = "/home")}>
            Go to Home
          </button>
          <button className="btn btn-ghost" onClick={goBackSmart}>
            Go Back
          </button>
        </div>

        <div className="eyebrow" style={{ marginTop: "var(--sp-5)" }}>
          Error code: <span className="num" style={{ color: "var(--text-2)", fontWeight: 700 }}>403</span>
        </div>
      </section>
    </div>
  );
}
